import { Box, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { React, useState } from 'react'
import { milestones } from '../utils/constants'
import Milestones from './Milestones'
import './CareerPath.css'
// function fetcDetail(year){
//       milestones.filter(item => item.year === year )  
// }
const CareerPath = () => {
    const [year, setYear] = useState('Present');
    let selectedMilestone = milestones.filter(item => item.year === year);
    return (
        <Box p={2} height={'100%'} >
            <Box textAlign={'center'}>
                <Typography variant='h4' sx={{ color: '#70FF00' }} display={'inline'}>milestones</Typography><Typography variant="h4" display={'inline'} sx={{ color: '#E0E0E0' }}>( )</Typography>
            </Box>
            <Stack width={'100%'}  direction={'column'} justifyContent={'flex-start'} alignItems={'center'}>
                <Stack direction={'row'} textAlign={'center'} justifyContent={'flex-start'} alignItems={'center'} sx={{overflow:'auto'}} maxWidth={'100%'} >
                    {milestones.map((item, idx) =>
                        <Milestones item={item} key={idx} year={year} setYear={setYear}  />
                    )}
                </Stack>
                <Box  width={'80%'} display={'flex'} justifyContent={'center'}>
                    <Stack direction={'column'} alignItems={'center'} justifyContent={'flex-start'}>
                        {/* <img src={selectedMilestone[0]?.image} className='milestone-img' alt='milestone'/> */}
                        <Typography textAlign={'center'} mt={2} variant='h5' fontWeight={'bolder'} color={'#F2F2F2'}>{selectedMilestone[0]?.title}</Typography>
                        <Typography textAlign={'center'} mt={1} variant='h6'  color={'#F2F2F2'}>{selectedMilestone[0]?.name}</Typography>
                        <Typography mt={2} variant='body' color={'#F2F2F2'} textOverflow={'wrap'}>{selectedMilestone[0]?.detail}</Typography>
                    </Stack>
                </Box>
            </Stack>

        </Box>
    )
}

export default CareerPath